function init() {
	let atTop = true;

	const header = document.querySelector('[data-header]');
	const headerContainer = document.querySelector('[data-header-container]');
	const logo = document.querySelector('[data-logo]');
	const menu = document.getElementById('primary-nav');
	const contactMenuItem = document.getElementById('primary-nav-menuitem-contact');

	if (
		"IntersectionObserver" in window &&
		"IntersectionObserverEntry" in window &&
		"intersectionRatio" in window.IntersectionObserverEntry.prototype &&
		header && logo && menu && headerContainer
	) {
		let observer = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting === true && atTop === false) {
				atTop = true;

				logo.classList.remove('scale-75');
				menu.classList.remove('lg:text-base');
				header.classList.add('py-6');
				header.classList.remove('pt-2', 'pb-1');
				headerContainer.classList.remove('shadow-md');

				contactMenuItem.style.paddingTop = null;
				contactMenuItem.style.paddingBottom = null;
			} else if (entries[0].isIntersecting === false && atTop === true) {
				atTop = false;

				logo.classList.add('scale-75');
				menu.classList.add('lg:text-base');
				header.classList.remove('py-6');
				header.classList.add('pt-2', 'pb-1');
				headerContainer.classList.add('shadow-md');

				contactMenuItem.style.paddingTop = '6px';
				contactMenuItem.style.paddingBottom = '6px';
			}

		});
		observer.observe(document.querySelector("[data-trigger]"));
	}
}

export default init;
